/* global Vue, TOPICS, FAQ */

import Accordion from './components/Accordion'

const FaqApp = Vue.createApp({
  name: 'FaqApp',
  components: { Accordion },
  template: '#faq-app-template',

  setup () {
    const filter = Vue.ref('all')

    const grouppedFaq = (key) => {
      return FAQ.filter(f => {
        return f.topic === key
      })
    }

    return {
      filter,
      grouppedFaq,
      FAQ,
      TOPICS,
    }
  },
})

const appElement = document.getElementById('faq-app')

if (appElement) FaqApp.mount(appElement)
